import React from 'react';
import { SimpleModal } from '@livable/saas-react-components';
import { ModalContent } from './modalContent';
export const ReimbursementModal = _ref => {
  let isOpen = _ref.isOpen,
    handleClose = _ref.handleClose,
    triggerRefresh = _ref.triggerRefresh,
    propertyIdExternal = _ref.propertyIdExternal;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    title: "Add new reimbursement information",
    trigger: null,
    isOpen: isOpen,
    handleClose: handleClose,
    noPadding: true
  }, /*#__PURE__*/React.createElement(ModalContent, {
    handleClose: handleClose,
    triggerRefresh: triggerRefresh,
    propertyIdExternal: propertyIdExternal
  }));
};